<template>
  <a-result status="500" sub-title="Coś poszło nie tak! Przepraszamy za problemy. Spróbuj ponownie później."
            title="500">
  </a-result>
</template>
<script>
export default {
  name: "Error500",
  data() {
    return {};
  },
  mounted() {
    this.$emit("loadedView");
    setTimeout(() => {
      window.location.href = "/";
    }, 10000)
  },
};
</script>
